export default __webpack_public_path__ + "static/loader-4d2f9bdeeeb47dbbd661b513d96001eb.gif";